import { Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const Footer = () => {
  const { user } = useAuth();
  const location = useLocation();

  // Don't render footer for logged-in users or on landing page
  if (user || location.pathname === '/') {
    return null;
  }

  const footerLinks = [
    { to: '/about', label: 'About' },
    { to: '/help', label: 'Help Centre' },
    { to: '/terms', label: 'Terms of Service' },
    { to: '/privacy', label: 'Privacy Policy' },
    { to: '/cookies', label: 'Cookie Policy' },
    { to: '/accessibility', label: 'Accessibility' },
    { to: '/ads', label: 'Ads info' },
    { to: '/blog', label: 'Blog' },
    { to: '/brand', label: 'Brand Resources' },
    { to: '/advertising', label: 'Advertising' },
    { to: '/business', label: 'Suremify for Business' },
    { to: '/news', label: 'News' },
    { to: '/settings', label: 'Settings' },
  ];

  return (
    <footer className='py-4 text-white bg-gradient-to-br from-green-600 via-green-700 to-green-800 mt-0'>
      <div className='px-4 mx-auto max-w-7xl sm:px-6 lg:px-8'>
        <nav className='flex flex-wrap gap-x-2 gap-y-2 justify-center items-center text-xs'>
          {footerLinks.map((link, index) => (
            <Fragment key={index}>
              <Link
                to={link.to}
                className='transition-colors hover:underline hover:text-green-200'
              >
                {link.label}
              </Link>
              {index < footerLinks.length - 1 && (
                <span className='text-green-200'>|</span>
              )}
            </Fragment>
          ))}
          <span className='text-green-200'>|</span>
          <span>© 2025 Suremify</span>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
